/* Generado por el instalador. No editar a mano. */
import { lazy } from 'react';
export const ASSISTANT_INSTALLED = true;

export const AssistantHubPage = lazy(() => import('../pages/AssistantHubPage'));
export function preload_AssistantHubPage() { return import('../pages/AssistantHubPage'); }
